const normalizeKey = item => {
	if (typeof item === 'string') {
		return item
	}

	return item?.clave
}

export const getUserPermissionKeys = auth => {
	return (auth?.permisos || []).map(normalizeKey).filter(Boolean)
}

export const canAccessByPermit = (item, auth) => {
	if (!item?.permit) {
		return true
	}

	const userPermissions = getUserPermissionKeys(auth)
	return userPermissions.includes(item.permit)
}

export const canAccessMenuItem = (item, auth) => {
	return canAccessByPermit(item, auth)
}
